const KEY = "collaboratorx.lastWorkspaceId";

export function getLastWorkspaceId(): string | null {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(KEY);
}

export function setLastWorkspaceId(workspaceId: string) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(KEY, workspaceId);
}

export function clearLastWorkspaceId() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(KEY);
}

export function resolvePostLoginPath(
  workspaces: { id: string }[],
  lastWorkspaceId: string | null,
): string {
  if (lastWorkspaceId && workspaces.some((w) => w.id === lastWorkspaceId)) {
    return `/workspaces/${lastWorkspaceId}`;
  }
  if (workspaces.length === 1) return `/workspaces/${workspaces[0]!.id}`;
  return "/hub";
}
